export const faqs = [
  {
    q: "「独家大瓜」的内容一般多久更新一次？",
    a: "站内保持每日更新，热点事件在发酵期会以小时为单位补充节点。首页的「爆料速递」滚动条与「最新爆料」列表展示的就是当天更新过的内容，重要事件会同步刷新追踪时间线。",
  },
  {
    q: "内容里的「某顶流男星」这类称呼是什么意思？",
    a: "这是站内的叙述规范。涉及具体个人的内容一律使用化名或模糊指代，只描述公开可见的行为与反应，不点名、不指向真实个人，也不对未经证实的事情做定性。",
  },
  {
    q: "「实锤 / 待证实 / 追踪中」这几个标注有什么区别？",
    a: "实锤表示有公开可查的物料或当事方明确回应；待证实表示已有一定线索，但缺少决定性证据或官方回应；追踪中表示事件仍在发酵，站内会持续跟进。这个分级是为了让你快速判断信息的分量。",
  },
  {
    q: "我可以向你们投稿爆料吗？",
    a: "可以。你可以通过「爆料投稿」邮箱发送线索，或在「关于我们」页面使用联系表单留言。我们会对来源做保密处理，并在发布前进行交叉核实，无法独立验证的部分会明确标注出来。",
  },
  {
    q: "为什么有些事件后来没有下文了？",
    a: "部分事件本身就没有决定性证据，或者当事方选择不回应，讨论热度自然会下降。站内不会为了流量强行续写结论，只会在出现新的公开节点时继续更新。",
  },
  {
    q: "你们会删改已经发布的内容吗？",
    a: "站内会保留发布记录。如果后续信息与早期判断不符，我们会发布更正说明并把新的节点补进时间线，而不是直接删除原有内容。",
  },
];